/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import { Box } from '@mantine/core';

// Components
import { ResetPassword } from '@features/update-password/components/ResetPassword';

// Styles
import classes from './update-password.module.css';

// I18n

// Localstorage
import { JwtPayload, jwtDecode } from 'jwt-decode';

// Router
import { useLocation } from 'react-router';

// Utils
import { CONTACT_US_AREC_URL } from '@config/constants/common';
import { REGEX_TOKEN } from '@config/constants/regex';
import { BackgroundImageAuth } from '@features/auth/components/BackgroundImageAuth';
import { FooterInfo } from '@features/auth/components/FooterInfo';
import { isTokenExpired } from '@utils/auth';

/* -------------------------------------------------------------------------- */
/*                                    Type                                    */
/* -------------------------------------------------------------------------- */
type CustomJwtPayload = Partial<JwtPayload> & {
	email: string;
};

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
const UpdatePassword = () => {
	/* ******************************** HOOKS ******************************* */

	const location = useLocation();
	const queryParams = new URLSearchParams(
		location.search
	);

	const token = queryParams.get('token')
		? queryParams.get('token')
		: '';

	const decodedPayload =
		token && REGEX_TOKEN.test(token)
			? jwtDecode<CustomJwtPayload>(token)
			: null;

	const email = decodedPayload
		? decodedPayload.email
		: '';

	const isValidToken = REGEX_TOKEN.test(
		token ? token : ''
	);

	/* ******************************** RENDERING ******************************* */
	return (
		<Box className={classes.container}>
			<Box className={classes.leftContainer}>
				<ResetPassword
					token={token || ''}
					email={email}
					isValidToken={isValidToken}
					isTokenExpired={isTokenExpired(token)}
				/>
				<FooterInfo contactUsUrl={CONTACT_US_AREC_URL} />
			</Box>
			<Box className={classes.rightContainer}>
				<BackgroundImageAuth
					url={
						'https://res.cloudinary.com/inuk/image/upload/v1750400298/inuk/IGLU/opia8p9xmtdivrydjt8d.jpg'
					}
				/>
			</Box>
		</Box>
	);
};

export default UpdatePassword;
